import React from 'react';
import { FaGavel, FaSearchDollar, FaTruck } from 'react-icons/fa';

function ServicesSection() {
    const services = [
        {
            icon: <FaGavel />,
            title: "Évaluation d'Antiquités",
            description: "Nous mettons à votre disposition des services professionnels d’évaluation, réalisés avec soin et expertise, pour déterminer la valeur de vos pièces antiques et vous offrir une estimation fiable et précise.",
        },
        {
            icon: <FaSearchDollar />,
            title: "Estimation Gratuite",
            description: "Nous vous offrons un service complet comprenant le déplacement et une expertise entièrement gratuits afin d'évaluer la valeur de vos objets en toute précision et transparence.",
        },
        {
            icon: <FaTruck />,
            title: "Service à Domicile",
            description: "Dès que notre offre est acceptée, nous fixons ensemble un rendez-vous pour collecter gratuitement les objets directement chez vous. Vous n’avez rien à gérez, nous nous occupons de tout.",
        },
    ];

    return (
        <section className="services-section" id="services">
            <h2>Nos Services</h2>
            <div className="services-container">
                {services.map((service, index) => (
                    <div key={index} className="service-item" style={{ '--order': index }}>
                        <div className="service-icon">{service.icon}</div>
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>

            <style jsx>{`
                .services-section {
                    padding: 80px 20px;
                    background-color: #20453d;
                    color: #C0A26B;
                    text-align: center;
                    position: relative;
                }

                .services-section h2 {
                    font-size: 2.5rem;
                    margin-bottom: 50px;
                    color: #C0A26B;
                    text-transform: uppercase;
                    animation: fadeInDown 1s ease-out;
                }

                .services-container {
                    display: grid;
                    /* Adjusted minmax to 250 for slightly smaller cards */
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 30px;
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 0 15px;
                    /* This ensures cards are centered in their cells */
                    justify-items: center;
                }

                .service-item {
                    background-color: #C0A26B;
                    border-radius: 15px;
                    /* Reduced padding to make cards smaller */
                    padding: 20px;
                    color: #20453d;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
                    transform: translateY(50px);
                    opacity: 0;
                    animation: slideUpFadeIn 1s ease-out forwards;
                    animation-delay: calc(0.2s * var(--order));
                    text-align: center;
                    /* Optional max-width to cap the card size further */
                    max-width: 300px;
                }

                .service-item:hover {
                    transform: scale(1.05);
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
                }

                .service-icon {
                    /* Slightly reduced icon size */
                    font-size: 2.5rem;
                    margin-bottom: 20px;
                    color: #20453d;
                    animation: rotateIn 1s ease;
                }

                /* Slightly reduced title size */
                .service-item h3 {
                    font-size: 1.3rem;
                    margin-bottom: 15px;
                }

                .service-item p {
                    font-size: 1rem;
                    line-height: 1.6;
                }

                @keyframes slideUpFadeIn {
                    from {
                        transform: translateY(50px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                @keyframes fadeInDown {
                    from {
                        opacity: 0;
                        transform: translateY(-30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes rotateIn {
                    from {
                        opacity: 0;
                        transform: rotate(-360deg);
                    }
                    to {
                        opacity: 1;
                        transform: rotate(0);
                    }
                }

                @media (max-width: 768px) {
                    .service-item {
                        padding: 15px;
                    }

                    .service-icon {
                        font-size: 2rem;
                    }
                }
            `}</style>
        </section>
    );
}

export default ServicesSection;
